import authService from "@lib/services/AuthService";

export const handleLogout = (): void => {
  authService.removeTokens();
  authService.removeRole();
};
